/* src/app/private/modules/sales-mail-hub/sales-mail-hub.component.scss */
/*# sourceMappingURL=sales-mail-hub.component.css.map */
